if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"features","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^webpack_sharing_consume_default_(react\-dom_react\-dom|styled\-components_styled\-components)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}